<template>
  <div class="subscription-licences">
    <!-- Le profil d'équipement de la borne posée, et l'assistant pour en changer -->
    <charging-point-profile-card v-if="chargingPoint" :charging-point="chargingPoint" @changed="reload" />

    <subscription-licences-list :key="reloads" :charging-point-id="chargingPoint.id"></subscription-licences-list>

  </div>
</template>

<script>


import SubscriptionLicencesList from "@/components/elements/SubscriptionLicencesList.vue"
import ChargingPointProfileCard from '@pages/Onboarding/ChargingPointProfileCard.vue'

export default {
  components: {
    ChargingPointProfileCard,
    SubscriptionLicencesList,
  },

  data() {
    return {
      reloads: 0,
    }
  },



  mounted() {

  },

  watch: {

  },

  computed: {
    chargingPoint() {
      return this.$parent.chargingPoint ?? null
    },

  },

  methods: {
    /** Après un changement de profil : la borne (son accès) et ses licences, relues. */
    reload() {
      this.reloads++
      if (typeof this.$parent.loadData === 'function') this.$parent.loadData()
    },
  },

}
</script>

<style lang="scss">

</style>
